export default __webpack_public_path__ + "e8af5916e46eac25115e603054256854.svg";